import { AlfaPaymentProvider, StripePaymentProvider, YooMoneyPaymentProvider } from './paymentProvider.types';

export const PAYMENT_PROVIDERS: [YooMoneyPaymentProvider, StripePaymentProvider, AlfaPaymentProvider] = [
  {
    provider: 'yoomoney',
    credentials: {
      AccountId: '',
      AccountSecretKey: '',
    },
  },
  {
    provider: 'stripe',
    credentials: {
      AccountSecretKey: '',
    },
  },
  {
    provider: 'alfa',
    credentials: {
      Login: '',
      Password: '',
      Token: '',
    },
  },
];
